module.exports = __webpack_public_path__ + "static/media/events.aef90dc9.png";